import client from "../client";
import clientAuth from "../clientAuth"

export default {
  // 
  // login: (userData) => client.post("session/login", {
  //   json: {
  //     email: email,
  //     password: password,
  //     device_name: "web"
  //   }
  // }),
  login: (userData) => clientAuth.post('session/login', { json: userData }),
  //
  logout: () => clientAuth.post("session/logout"),

};